// third-party
// import { FormattedMessage } from 'react-intl';

// assets
import {
  DollarOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

// type

// icons
const icons = {
  DollarOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  FileDoneOutlined,
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const mitraPages = {
  id: "mitra-group-pages",
  title: <FormattedMessage id="pages" />,
  type: "group",
  children: [
    {
      id: "mitra",
      title: <FormattedMessage id="mitra" />,
      type: "collapse",
      icon: icons.FileDoneOutlined,
      children: [
        {
          id: "unit",
          title: <FormattedMessage id="my unit" />,
          type: "item",
          url: "/unit/mitra",
          // target: true,
        },
        // {
        //   id: "building",
        //   title: <FormattedMessage id="building" />,
        //   type: "item",
        //   url: "/properties/building",
        //   // target: true,
        // },
        // {
        //   id: "floor",
        //   title: <FormattedMessage id="floor" />,
        //   type: "item",
        //   url: "/properties/floor",
        //   // target: true,
        // },
        // {
        //   id: "pks",
        //   title: <FormattedMessage id="Perjanjian Kerja Sama" />,
        //   type: "item",
        //   url: "/pks/mitra",
        //   // target: true,
        // },
      ],
    },
    // {
    //   id: "contact-us",
    //   title: <FormattedMessage id="contact-us" />,
    //   type: "item",
    //   url: "/contact-us",
    //   icon: icons.PhoneOutlined,
    //   // target: true,
    // },
  ],
};

export default mitraPages;
